import React , { useEffect,  useState } from "react"; 
import {  Table } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell"; 
import TableRow from "@material-ui/core/TableRow";
import * as Actions from "../../store/action/fileManagement";
import { useDispatch } from "react-redux";
import getDateFromString from "../../utils/getDateFromString"
import { makeStyles } from "@material-ui/core/styles";
import {VscNewFile} from "react-icons/vsc";
import {Button, Grid,} from "@mui/material";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import {IoCloseOutline} from "react-icons/io5";
import {RiDeleteBin6Line} from "react-icons/ri";
import {addMetaDataToFile, uploadFile} from "../../store/action/fileManagement";
import {TailSpin} from "react-loader-spinner";
import {translateDocType} from "../../utils/translateDocType";
import { getPartyDetails } from '../../store/action/party';
import { updateStatusClaim } from '../../store/action/claim';
import { getNextClaimStatus } from '../../utils/claimStatusProgress';
import { addEventLog } from '../../store/action/claimManagement';
import PreviewPDF from '../TaskListSection/PreviewPDF';
import { toast } from "react-toastify";
import { hasAuthorities } from "../../utils/authoritiesUtils";
import { UploadProgressDialog, UploadErrorDialog } from "../UploadProgressDialog";

const useStyles = makeStyles((theme) => ({
    tableHeadRows: {whiteSpace: "nowrap" , fontFamily : 'Poppins', fontWeight : 600 ,fontSize :12, lineHeight:'18px' ,color :'rgba(181, 181, 195, 1)',  border:0 ,  background: 'rgba(243, 246, 249, 1)' , padding : '1%' } ,
    tableCellSmall1: { fontFamily : 'Poppins', fontWeight : 600 ,fontSize :15, lineHeight:'22.5px' ,color :'rgba(70, 78, 95, 1)' ,  borderBottom: '1px solid  rgba(0, 0, 0, 0.08)'  },
    tableCellSmall: { fontFamily : 'Poppins', fontWeight : 400 ,fontSize :15, lineHeight:'22.5px' ,color :'rgba(70, 78, 95, 1)' ,  borderBottom: '1px solid  rgba(0, 0, 0, 0.08)'  },
    uploadFileIcon:{
        display: "flex",
        justifyContent: "right",
        alignItems: "center",
        color: "rgba(187, 200, 8, 1)",
        backgroundColor: "rgb(255, 255, 255)",
        border: "none",
        cursor: "pointer",
        padding: "10px",
        fontSize: "27px",
        position: "absolute",
        right: "20px",
    },
    dialogPaper: {
        maxWidth: '100%',
        width: "933px",
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
    },
    dialogTitle: {
        height: "60px",
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: "rgba(244, 244, 244, 1)",
        color: "rgba(33, 33, 33, 1)",
        fontSize: "15px",
        fontWeight: 500,
        fontFamily: "Poppins",
    },
    closeButton: {
        cursor: 'pointer',
        marginLeft: "610px",
        textAlign: "right",
        alignItems: 'center',
    },
    radioContainer: {
        padding: theme.spacing(1),
        //flexBasis: '30%',
    },
    radioInput: {
        appearance: 'none',
        borderRadius: '50%',
        border: 'none',
        backgroundColor: 'rgba(229, 234, 238, 1)',
        width: '20px',
        height: '20px',
        marginRight: '8px',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none',
        '&:checked': {
            backgroundColor: 'rgba(60, 101, 86, 1)',
            border: '2px solid rgba(60, 101, 86, 1)',
        },
        '&:checked::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: 'rgba(60, 101, 86, 1)',
            transform: 'translate(-50%, -50%)',
        },
    },
    previewContainer: {
        width: '100%',
        height: '90%',
        //paddingTop: theme.spacing(1),
        padding: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#f3f6f9',
        boxSizing: 'border-box',
        position: 'relative',
        overflow: 'hidden',
    },
    previewImage: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
        flexGrow: 1,
    },
    previewPDF: {
        width: '300px',
        height: '250px',
        flexGrow: 1,
        display: 'block',
        // overflow: 'auto',
        // objectFit: 'contain',
        border: 'none',
    },
    documentTypeLabel: {
        fontFamily: 'Poppins',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '18px',
        textAlign: 'left',
        color: 'rgba(70, 78, 95, 1)',
    },
    uploadRectangle: {
        backgroundColor: 'rgba(243, 246, 249, 1);',
    },
    uploadTextPrimary: {
        color: "rgba(60, 101, 86, 1)",
        fontWeight: 600,
        fontFamily: "Poppins",
        fontSize: "14px",
        textAlign: "center",
        marginBottom: "15px",
    },
    footerContainer: {
        background: 'rgba(244, 244, 244, 1)',
        padding: '10px',
        textAlign: 'right',
        height: "46px",
    },
    truncatedText: {
        display: 'inline-block',
        maxWidth: '200px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        '&:hover::after': {
            content: 'attr(data-fullname)',
            position: 'absolute',
            top: '100%',
            left: 0,
            backgroundColor: 'rgba(0,0,0,0.8)',
            color: '#fff',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            zIndex: 1000,
            whiteSpace: 'normal',
            width: 'auto',
            maxWidth: '300px',
        }
    },
}));

export default function DocSection(props) {
    const classes = useStyles();
    const [docOfClaim, setDocOfClaim] = useState([]);
    const [loading, setLoading] = useState(true);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [filePreview, setFilePreview] = useState(null);
    const [selectedDocumentType, setSelectedDocumentType] = useState('');
    const [openPreviewPDF, setOpenPreviewPDF] = useState(false);
    const [previewPdfUrl, setPreviewPdfUrl] = useState('');
    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadErrorOpen, setUploadErrorOpen] = useState(false);
    const [uploadErrorMsg, setUploadErrorMsg] = useState('');
    const [pictureCounts, setPictureCounts] = useState({ before: 0, after: 0 });
    const [missingPicturesMsg, setMissingPicturesMsg] = useState('');
    const renderUploadDoc = props.renderUploadDoc
    // delete actif uniquement en vue sinistre (enableDelete) — jamais dans les tâches todo
    const canDeleteFile = !!props.enableDelete && hasAuthorities("DELETE_PHOTO");
    const dispatch = useDispatch();
    const username = localStorage.getItem('username');
    //console.log("claim number ", props.claimNumber)
    const documentTypes = [
        { label: "Rapport Finale d'expertise", code: "FINAL_REPORT" },
        { label: "Rapport préliminaire d'expertise", code: "PRELIMINARY_REPORT" },
        { label: "Permis", code: "DRIVING_LICENCE" },
        { label: "Honnoraire", code: "HONORARY" },
        { label: "Facture", code: "INVOICE" },
        { label: "Devis", code: "QUOTATION" },
        { label: "Constat", code: "CLAIM_REPORTING_DOCUMENT" },
        { label: "PV police", code: "POLICE_PV" },
        { label: "Carte grise", code: "CAR_REGISTRATION" },
        { label: "CNI", code: "CIN" },
        { label: "Quittance", code: "VOUCHER" },
        { label: "Bon de sortie", code: "CAR_EXIT_VOUCHER" },
        { label: "Constat Preliminaire", code: "CP" },
        { label: "Autres", code: "OTHER" },
    ];

      const fetchDocOfClaim = async () => {
          setLoading(true);
          try {
            const response = await dispatch(Actions.getAllFileForClaim(props.claimNumber));
            const countPictures = (type) => response.filter((file) =>
              file.metadata.some((metadata) => metadata.value === type)
            ).length;
            setPictureCounts({
              before: countPictures("PICTURE_BEFORE_REPARATION"),
              after: countPictures("PICTURE_AFTER_REPARATION"),
            });
            const docData = response.filter((file) => {
              return !file.metadata.some((metadata) => [
                "PICTURE_AFTER_REPARATION",
                "PICTURE_BEFORE_REPARATION",
                "OTHER_CAR_PICTURE",
              ].includes(metadata.value));
            }); 
            setDocOfClaim(docData);
            setLoading(false);
          } catch (error) {
            console.error("Error fetching documents:", error);
          } finally {
            setLoading(false);
          }
        };
      const viewDoc = async (doc) => {
        // Check if the document is a constat by looking at the metadata
        const isConstat = docOfClaim.find(file => file.file.location === doc)?.metadata.some(meta => meta.value === 'CLAIM_REPORTING_DOCUMENT');
        
        if (isConstat) {
            // For constat, open in new tab as before
            const url = `${process.env.REACT_APP_BACKEND_URL_MS_FILEMANAGEMENT}${doc}`;
            window.open(url, '_blank');
        } else {
            try {
                setLoading(true);
                // Fetch the file with proper authorization
                const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_MS_FILEMANAGEMENT}${doc}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    },
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch document');
                }

                // Convert the response to blob
                const blob = await response.blob();
                // Create a URL for the blob
                const url = URL.createObjectURL(blob);
                
                setPreviewPdfUrl(url);
                setOpenPreviewPDF(true);
            } catch (error) {
                console.error('Error fetching document:', error);
                // You might want to show an error message to the user here
            } finally {
                setLoading(false);
            }
        }
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        const validType = 'application/pdf';

        if (file && file.type === validType) {
            setSelectedFile(file);
            setFilePreview(URL.createObjectURL(file));
            setDialogOpen(true);
        } else {
            toast.error("Seuls les fichiers PDF sont acceptés");
        }
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setSelectedFile(null);
        setFilePreview(null);
        setSelectedDocumentType([]);
    };

    const handleDocumentTypeChange = (event) => {
        setSelectedDocumentType(event.target.value);
    };

    const handleDeleteFile = async (uid) => {
        if (!window.confirm('Êtes-vous sûr de vouloir supprimer ce fichier ?')) return;
        try {
            await dispatch(Actions.deleteFileImage(uid));
            toast.success('Fichier supprimé avec succès');
            fetchDocOfClaim();
        } catch (error) {
            console.error('Error deleting file:', error);
            toast.error('Erreur lors de la suppression du fichier');
        }
    };

    const viewConstat = async () => {
    let tempUrl = null;

    try {
        // --- Validation des données ---
        const party = await getPartyDetails(props.partyUid);
        if (!party?.identityNumber) throw new Error("Détails du parti invalides.");

        const { policyNumber, reportingNumber, claimNumber } = props;
        if (!policyNumber || !reportingNumber || !claimNumber)
        throw new Error("Détails de police manquants.");

        // --- Construction des query params ---
        const queryParams = new URLSearchParams({
        idSouscripteur: party.identityNumber,
        policeNumeroPolice: policyNumber,
        numeroDeclaration: reportingNumber,
        numSinistre: claimNumber,
        }).toString();

        // --- Fetch du PDF depuis ton backend ---
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_STAR_INTERFACAGE}/openConstat?${queryParams}`, {
        method: "GET",
        headers: { Accept: "application/pdf" },
        });

        if (!response.ok) {
        if (response.status === 404) throw new Error("CONSTAT_NOT_FOUND");
        throw new Error(`Erreur serveur (${response.status})`);
        }

        // --- Lecture du PDF ---
        const blob = await response.blob();
        if (blob.size === 0) throw new Error("Le fichier PDF est vide.");

        // --- Création d'une URL temporaire pour affichage ---
        tempUrl = URL.createObjectURL(blob);
        setPreviewPdfUrl(tempUrl);
        setOpenPreviewPDF(true);

        // Ouvre le PDF dans un nouvel onglet
        // window.open(tempUrl, "_blank");

    } catch (error) {
        console.error("Erreur lors de la récupération du constat:", error);

        if (tempUrl) URL.revokeObjectURL(tempUrl);

        if (error.message === "CONSTAT_NOT_FOUND") {
        alert("Le constat PDF demandé n’a pas été trouvé.");
        } else if (error.message.includes("NetworkError")) {
        alert("Erreur réseau : impossible de contacter le serveur.");
        } else {
        alert(`Erreur lors du chargement du constat : ${error.message}`);
        }
    }
    };
 
    const handleDialogValidate = async () => {
        if (!selectedFile || !selectedDocumentType) {
            alert('Please select a file and document type.');
            return;
        }
        if (selectedDocumentType === 'FINAL_REPORT') {
            const missing = [];
            if (pictureCounts.before < 1) missing.push('une image avant réparation');
            if (pictureCounts.after < 1) missing.push('une image après réparation');
            if (missing.length) {
                setMissingPicturesMsg(`Impossible d'ajouter le rapport final : il faut au moins ${missing.join(' et ')}.`);
                return;
            }
        }
        setLoading(true);
        setUploadDialogOpen(true);
        setUploadProgress(0);
        try {
            //console.log("selectedDocumentType", selectedDocumentType)
            const formData = new FormData();
            formData.append('fileUploaded', selectedFile);
            formData.set('createdBy', username);
            formData.set('key', 'NUM_SIN');
            formData.set('value', props.claimNumber);

            const uploadResponse = await dispatch(uploadFile(formData, setUploadProgress));
            const uid = uploadResponse.uid;

            const metaData = {
                key: 'TYPE_DOCUMENT',
                value: selectedDocumentType,
            };

            await dispatch(addMetaDataToFile(uid, metaData));

            const hasFinalReport = docOfClaim.some((doc) =>
                doc.metadata?.some((meta) => meta.value === 'FINAL_REPORT')
            );
            if (selectedDocumentType === 'FINAL_REPORT' && !hasFinalReport) {
                try {
                    await addEventLog(props.claimNumber, 'Envoi rapport final', username);
                } catch (error) {
                    console.error('[addEventLog]', error);
                }
            }

            const nextStatus = selectedDocumentType === 'FINAL_REPORT'
                ? getNextClaimStatus(props.claimStatus, {
                    hasBefore: pictureCounts.before > 0,
                    hasAfter: pictureCounts.after > 0,
                    hasFinalReport: true,
                })
                : null;
            if (nextStatus === 'CLOSED') {
                try {
                    await dispatch(updateStatusClaim(props.claimNumber, 'CLOSED'));
                    props.onStatusChange?.('CLOSED');
                    toast.success('Sinistre clôturé');
                } catch (error) {
                    console.error('[updateStatusClaim]', error);
                    toast.error('Rapport ajouté mais la clôture du sinistre a échoué');
                }
            }
            // console.log("uploadResponse", uploadResponse)
            // console.log("docOfClaim", docOfClaim)

            const newFile = {
                file: {
                    fileName: uploadResponse.fileName,
                    createdAt: new Date().toISOString(),
                },
                metadata: [metaData]
            };

            //console.log("newFile", newFile)
            setDocOfClaim([...docOfClaim, newFile]);

            setDialogOpen(false);
            setSelectedFile(null);
            setFilePreview(null);
            setSelectedDocumentType('');
        } catch (error) {
            console.error('Error uploading file:', error);
            setUploadErrorMsg("Une erreur est survenue lors de l'ajout du document");
            setUploadErrorOpen(true);
        } finally {
            setUploadDialogOpen(false);
            setUploadProgress(0);
            setLoading(false);
            fetchDocOfClaim();
        }
    };
    useEffect(() => {
        fetchDocOfClaim();
      }, []);

    const truncateFilename = (filename, maxLength = 20) => {
        if (filename.length <= maxLength) return filename;

        const lastDotIndex = filename.lastIndexOf('.');
        if (lastDotIndex === -1) {
            return `${filename.substring(0, maxLength)}...`;
        }

        const extension = filename.substring(lastDotIndex);
        const nameWithoutExtension = filename.substring(0, lastDotIndex);
        const availableLength = maxLength - extension.length - 3;

        if (availableLength <= 0) {
            return `...${extension}`;
        }

        return `${nameWithoutExtension.substring(0, availableLength)}...${extension}`;
    };

        return (
            <div style={{padding: "40px"}}>
               {/* // {!renderUploadDoc && */}
                    <div style={{position: "relative", marginBottom: "50px"}}>
                        <button className={classes.uploadFileIcon}
                                onClick={() => document.getElementById('fileInput').click()}>
                            <VscNewFile/>
                        </button>
                        <input
                            type="file"
                            accept="image/*,application/pdf"
                            id="fileInput"
                            style={{display: 'none'}}
                            onChange={handleFileChange}
                        />
                    </div>
                {/* } */}
                <Table
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    size="small"
                >
                <TableCell width={'17%'} height={'43px'} align="left" className={classes.tableHeadRows}
                               style={{borderTopLeftRadius: '6px', borderBottomLeftRadius: '6px'}}>Type de
                        document</TableCell>
                    <TableCell width={'25%'} height={'43px'} align="left"
                               className={classes.tableHeadRows}>Nom</TableCell>
                    <TableCell width={'13%'} height={'43px'} align="left"
                               className={classes.tableHeadRows}>Date</TableCell>
                    <TableCell width={'40%'} height={'43px'} align="left"
                               className={classes.tableHeadRows}>Commentaire</TableCell>
                    <TableCell width={'10%'} height={'43px'} align="left"
                               className={classes.tableHeadRows}>Statut</TableCell>
                    <TableCell width={'10%'} height={'43px'} align="right" className={classes.tableHeadRows}
                               style={{borderTopRightRadius: '6px', borderBottomRightRadius: '6px'}}>{" "}</TableCell>
                    <TableBody>
                            {/* <TableRow
                                hover
                                //tabIndex={-1}
                                key="1"
                                style={{height: "48px"}}
                            >
                                <TableCell
                                    align="left"
                                    className={classes.tableCellSmall}
                                >
                                    Constat
                                </TableCell>
                                <TableCell
                                    align="left"
                                    style={{
                                        fontFamily: 'Poppins',
                                        fontWeight: 400,
                                        fontSize: 14,
                                        lineHeight: '21px',
                                        color: '#BBC808',
                                        borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
                                    }}
                                    title={`Constat_${props.claimNumber}.pdf`}
                                >
                                    <span
                                        className={classes.truncatedText}
                                        data-fullname={`Constat_${props.claimNumber}.pdf`}
                                    >
                                        {truncateFilename(`Constat_${props.claimNumber}.pdf`, 25)}
                                    </span>
                                </TableCell>
                                <TableCell
                                    align="left"
                                    style={{
                                        fontFamily: 'Poppins',
                                        fontWeight: 400,
                                        fontSize: 14,
                                        lineHeight: '21px',
                                        color: '#BBC808',
                                        borderBottom: '1px solid  rgba(0, 0, 0, 0.08)'
                                    }}
                                >
                                     N/A
                                </TableCell>
                                <TableCell
                                    align="left"
                                    style={{
                                        fontFamily: 'Poppins',
                                        fontWeight: 400,
                                        fontSize: 14,
                                        lineHeight: '21px',
                                        color: '#BBC808',
                                        borderBottom: '1px solid  rgba(0, 0, 0, 0.08)'
                                    }}
                                >
                                    N/A
                                </TableCell>
                                <TableCell
                                    align="left"
                                    style={{
                                        fontFamily: 'Poppins',
                                        fontWeight: 400,
                                        fontSize: 14,
                                        lineHeight: '21px',
                                        color: '#BBC808',
                                        borderBottom: '1px solid  rgba(0, 0, 0, 0.08)'
                                    }}
                                >
                                    N/A
                                </TableCell>
                                <TableCell
                                    align="right"
                                    className={classes.tableCellSmall}
                                >
                                    <button style={{
                                        width: '61px',
                                        height: '34px',
                                        borderRadius: '6px',
                                        background: 'rgba(240, 243, 199, 1)',
                                        border: 0,
                                        fontFamily: 'Poppins',
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        lineHeight: '18px',
                                        color: 'rgba(60, 101, 86, 1)'
                                    }}
                                            onClick={() => viewConstat()}>
                                        Voir
                                    </button>
                                </TableCell>

                            </TableRow>
                                     */}
                        {docOfClaim.length > 0 &&
                            <>
                                {docOfClaim
    .sort((a, b) => new Date(a.file.createdAt) - new Date(b.file.createdAt))
    .map((row, index) => (
        <TableRow
            hover
            key={row._id}
            style={{ height: "48px" }}
        >
            <TableCell align="left" className={classes.tableCellSmall}>
                {translateDocType(row.metadata.find(data => data.key === 'TYPE_DOCUMENT')?.value)}
            </TableCell>
            <TableCell
                align="left"
                style={{
                    fontFamily: 'Poppins',
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: '21px',
                    color: '#BBC808',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
                }}
                title={`${row?.file?.fileName}.pdf`}
            >
                                    <span
                                        className={classes.truncatedText}
                                        data-fullname={`${row?.file?.fileName}.pdf`}
                                    >
                                        {truncateFilename(`${row?.file?.fileName}.pdf`, 25)}
                                    </span>
            </TableCell>
            <TableCell
                align="left"
                style={{
                    fontFamily: 'Poppins',
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: '21px',
                    color: '#BBC808',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
                }}
            >
                {getDateFromString(row?.file?.createdAt.toString())}
            </TableCell>
            <TableCell
                align="left"
                style={{
                    fontFamily: 'Poppins',
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: '21px',
                    color: '#BBC808',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
 
                }}
                title={row?.comment || ''}
            >
                {row?.comment || 'N/A'}
            </TableCell>
            <TableCell style={{fontFamily: "Poppins", color: "black", fontSize: "15px"}}>
                <span style={{
                    padding: "5px",
                    borderRadius: "51px",
                    border: 0,
                    fontFamily: "Poppins",
                    fontSize: "10.17px",
                    fontWeight: 400,
                    lineHeight: "15.26px",
                    color:
                        row?.status === "VALID"
                            ? "rgba(187, 200, 8, 1)"
                            : row?.status === "REJECTED"
                                ? "rgba(255, 54, 54, 1)"
                                : row?.status === "RECEIVED"
                                    ? "rgba(0, 114, 190, 1)"
                                    : "rgba(255, 168, 0, 1)",
                    backgroundColor:
                        row?.status === "VALID"
                            ? "rgba(240, 243, 199, 1)"
                            : row?.status === "REJECTED"
                                ? "rgba(255, 229, 229, 1)"
                                : row?.status === "RECEIVED"
                                    ? "rgba(224, 240, 255, 1)"
                                    : "rgba(255, 168, 0, 0.3)",
                }}>
                    {row?.status || 'N/A'}
                </span>
            </TableCell>
            <TableCell align="right" className={classes.tableCellSmall}>
                <div style={{ display: 'flex', gap: '6px', justifyContent: 'flex-end' }}>
                    <button
                        style={{
                            width: '61px',
                            height: '34px',
                            borderRadius: '6px',
                            background: 'rgba(240, 243, 199, 1)',
                            border: 0,
                            fontFamily: 'Poppins',
                            fontSize: '12px',
                            fontWeight: 600,
                            lineHeight: '18px',
                            color: 'rgba(60, 101, 86, 1)',
                            cursor: 'pointer',
                        }}
                        onClick={() => viewDoc(row?.file?.location)}
                    >
                        Voir
                    </button>
                     {canDeleteFile && (
                    <button
                        style={{
                            width: '34px',
                            height: '34px',
                            borderRadius: '6px',
                            background: 'rgba(240, 243, 199, 1)',
                            border: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            color: 'rgba(60, 101, 86, 1)',
                            fontSize: '16px',
                        }}
                        onClick={() => handleDeleteFile(row?.file?.uid)}
                        title="Supprimer"
                    >
                        <RiDeleteBin6Line />
                    </button>   
                     )}
                </div>
            </TableCell>
        </TableRow>
    ))}

                                </>
                             }
                    </TableBody>
                </Table>

                <Dialog
                    classes={{ paper: classes.dialogPaper}}
                    open={dialogOpen} onClose={handleDialogClose} maxWidth="md" fullWidth>
                    <DialogTitle className={classes.dialogTitle}>
                        Téléchargement document
                        <IoCloseOutline className={classes.closeButton} size={24} onClick={handleDialogClose} />
                    </DialogTitle>
                    <DialogContent className={classes.dialogContent}>
                        <Grid container>
                            <Grid item xs={4} className={classes.radioContainer}>
                                    <div style={{
                                        color: "rgba(60, 101, 86, 1)",
                                        fontWeight: 600,
                                        fontFamily: "Poppins",
                                        fontSize: "14px",
                                        lineHeight: '21px',
                                        textAlign: 'left',
                                        marginBottom: "5px"
                                    }}>
                                        
                                        Type du document
                                    </div>
                                    <Grid container direction="column">
                                {documentTypes.map((type) => (
                                < div style={{ display : 'flex' , padding : '3px' , alignItems:'center'}}>
                                    <input
                                     type="radio"
                                     name="documentType"
                                     value={type.code}
                                     checked={selectedDocumentType === type.code}
                                     onClick={handleDocumentTypeChange}
                                     className={classes.radioInput}
                                 />
                                    <label key={type.code} className={classes.documentTypeLabel}>
                                       
                                        {type.label}
                                    </label></div>
                                    
                                ))}
                                </Grid>
                            </Grid>
                            <Grid item xs={8} className={classes.previewContainer}>
                                {filePreview && (
                                    <div className={classes.uploadRectangle}>
                                        <div className={classes.uploadTextPrimary}>
                                            Aperçu du document
                                        </div>
                                        <div>
                                            {loading ? (
                                                <TailSpin color="rgba(187, 200, 8, 1)" radius={"10px"}/>
                                            ) : (
                                                <>
                                                    {selectedFile.type.startsWith('image') && (
                                                        <img src={filePreview} alt="File Preview" className={classes.previewImage} />
                                                    )}
                                                    {selectedFile.type === 'application/pdf' && (
                                                        <embed
                                                            src={filePreview}
                                                            type="application/pdf"
                                                            className={classes.previewPDF}
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                )}

                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className={classes.footerContainer}>
                        <Button
                            style={{
                                fontFamily: 'Poppins',
                                fontSize: '10.76px',
                                fontWeight: 600,
                                lineHeight: '16.14px',
                                textAlign: 'left',
                                color: 'rgba(255, 54, 54, 1)',
                                background: 'rgba(255, 229, 229, 1)',
                                width: '62px',
                                height: '26px',
                                borderRadius: '5.38px',
                                marginRight: '10px',
                                '&:hover': {
                                    background: 'rgba(255, 229, 229, 1)',
                                },
                            }}
                            onClick={handleDialogClose}>
                            Annuler
                        </Button>
                        <Button
                            style={{
                                fontFamily: 'Poppins',
                                fontSize: '10.76px',
                                fontWeight: 600,
                                lineHeight: '16.14px',
                                textAlign: 'left',
                                color: 'rgba(255, 255, 255, 1)',
                                background: 'rgba(60, 101, 86, 1)',
                                width: '61.08px',
                                height: '26.71px',
                                borderRadius: '5.38px',
                                marginRight: "10px",
                                '&:hover': {
                                    background: 'rgba(187, 200, 8, 1)',
                                },
                            }}
                            onClick={() => {
                                handleDialogValidate().then(r => console.log(r));
                            }}
                        >
                            Valider
                        </Button>
                    </DialogActions>
                </Dialog>

                <PreviewPDF
                    pdfUrl={previewPdfUrl}
                    open={openPreviewPDF}
                    onClose={() => setOpenPreviewPDF(false)}
                />

                <UploadProgressDialog
                    open={uploadDialogOpen}
                    progress={uploadProgress}
                    current={1}
                    total={1}
                />
                <UploadErrorDialog
                    open={uploadErrorOpen}
                    message={uploadErrorMsg}
                    onClose={() => setUploadErrorOpen(false)}
                />

                <Dialog
                    open={!!missingPicturesMsg}
                    onClose={() => setMissingPicturesMsg('')}
                    aria-labelledby="missing-pictures-dialog-title"
                >
                    <DialogTitle id="missing-pictures-dialog-title">Photos manquantes</DialogTitle>
                    <DialogContent style={{ fontFamily: 'Poppins', fontSize: 14, color: 'rgba(70, 78, 95, 1)' }}>
                        {missingPicturesMsg}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            style={{
                                fontFamily: 'Poppins',
                                fontSize: '10.76px',
                                fontWeight: 600,
                                color: 'rgba(255, 255, 255, 1)',
                                background: 'rgba(60, 101, 86, 1)',
                                borderRadius: '5.38px',
                                marginRight: '10px',
                            }}
                            onClick={() => setMissingPicturesMsg('')}
                        >
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>

            </div>
        )
}
 